import { ApolloError } from "@apollo/client";

// The app's standard translation of an ApolloError into user-facing copy.
// Extracted from showErrorToast so a surface that reports a failure *inline*
// (a modal panel, say) can show the same translated message the toast would,
// instead of falling back to its own generic text.
//
// Returns undefined when there is no GraphQL error to translate — i.e. a
// network-only failure. There is deliberately no copy for that case here:
// callers own it, because a toast has nothing useful to say about it while an
// inline panel can offer a retry.
export function getUserFacingErrorMessage(
  error: ApolloError | undefined
): string | undefined {
  const graphQLError = error?.graphQLErrors?.[0];
  if (!graphQLError) return undefined;
  if (graphQLError.message.includes("Access is denied")) {
    return "You do not have permission for this action. Contact your administrator.";
  }
  if (graphQLError.extensions?.errorType === "BAD_REQUEST") {
    return graphQLError.message;
  }
  return "Something went wrong";
}

export function showErrorToast(error: ApolloError, showToast: any) {
  // Unchanged behavior: a network-only failure (no graphQLErrors) shows no
  // toast, exactly as before.
  const message: string | undefined = getUserFacingErrorMessage(error);
  if (!message) return;
  showToast({ message, type: "error" });
}
